
import React, { useEffect, useRef } from 'react';
import './MainSectionAbouts.css';

function MainSectionAbouts() {

  return (
    <>
      <section className="aboutus" id="About" aria-labelledby="about-title">
  <div className="content">
    <h2 id="about-title" className="sr-only">About Us - Captain and Boat</h2>

    <div className="projects">

      {/* CAPTAIN BLOCK */}
      <article className="captainProject">
        <header className="pj-title-captain">
          <h3>"ME" The Captain</h3>
        </header>

        <figure className="proj-img-capt">
          <img src="/Assets/captain-nello.JPG" alt="Photo of the Captain" />
        </figure>

        <div className="captainDesc">
          <p className="captainp">
           My story begins in 1936 when my grandfather opened one of the first beach establishments in Positano.
                  Growing up surrounded by the sea and boats, I developed an unbreakable bond with these waters.
                  My journey took me far and wide, eventually leading me aboard the legendary Amerigo Vespucci,
                  the training ship of the Italian Navy, where I honed my seamanship skills.
                  But my greatest battle wasn’t at sea — I fought and defeated cancer. 
                  That experience brought me back to my roots, to Positano,
                  with a new purpose: to share the beauty of the Amalfi Coast with
                   those who wish to discover it from the sea, just as I have known it since childhood.
                   <br/>Welcome aboard! </p>
          
        </div>
      </article>

      <article className="boatProject">
        <header className="pj-title-boat">
          <h3>The Boat</h3>
        </header>

        <figure className="pj-img-boat">
          <img src="/Assets/TheBoat.jpg" className="boatImg" alt="Photo of the boat in the sea" />
        </figure>

        <div className="boatDesc">
          <p className="boatp">
            Her name is <strong>Zia Phan</strong>, she is a 28-foot Gozzo from the Amalfi coast, a traditional Italian boat that is perfect for 
                  leisure use. These boats are known for their classic design, sturdy construction, and excellent 
                  handling in choppy waters. A Gozzo of this size typically has a spacious cockpit area with comfortable 
                  seating for passengers, as well as a small cabin with basic amenities such as a bed, a toilet, and a kitchenette,
                  that may be equipped with a small fridge, allowing 
                  passengers to prepare simple meals and snacks while on board. 
                  Overall, a 28-foot Gozzo from the Amalfi coast is a charming and comfortable boat that is perfect for day 
                  trips or short-term cruises along the beautiful coastline of southern Italy.</p>
        </div>
      </article>

    </div>
  </div>
</section>

    </>
  );
}

export default MainSectionAbouts;
